import React from "react";
import {IQuestionGroup} from "../../../data/interfaces/IQuestionGroup";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import {QuestionType} from "../../../data/enums/QuestionType";
import {RadioQuestionComponent} from "../radioQuestionComponent";
import {CheckBoxQuestionComponent} from "../checkBoxQuestionComponent";
import {SliderQuestionComponent} from "../sliderQuestionComponent";
import {SwitchQuestionComponent} from "../switchQuestionComponent";
import "./style.scss";


export function GroupComponent(props: {
    group: IQuestionGroup,
    onChange: (node: IQuestion) => void;
}) {

    const {group, onChange} = props;

    return (
        <div className="survey-form-section">
            {
                (group.text !== undefined) && (
                    <label className="survey-form-section-label">
                        {group.text}
                    </label>
                )
            }

            <div className="survey-form-section-content">
                {
                    group.questions.map((q, qi) => {
                        switch (q.questionType) {
                            case QuestionType.SingleChoice:
                                return (
                                    <RadioQuestionComponent
                                        key={qi}
                                        question={q}
                                        onChange={onChange}
                                    />
                                );
                            case QuestionType.MultipleChoice:
                                return (
                                    <CheckBoxQuestionComponent
                                        key={qi}
                                        question={q}
                                        onChange={onChange}
                                    />
                                );
                            case QuestionType.Scale:
                                return  (
                                    <SliderQuestionComponent
                                        key={qi}
                                        question={q}
                                        onChange={onChange}
                                    />
                                )
                            case QuestionType.YesNo:
                                return (
                                    <SwitchQuestionComponent
                                        key={qi}
                                        question={q}
                                        onChange={onChange}
                                    />
                                )
                            default:
                                return <></>
                        }
                    })
                }
                {
                    group.groups.map((g, gi) => {
                        return (
                            <GroupComponent
                                key={gi}
                                group={g}
                                onChange={onChange}
                            />
                        );
                    })
                }
            </div>

        </div>
    )
}